import { Component, Input } from '@angular/core';
import { ImportedFileError } from '@src/model/importedFileError';
import { NgxDatatableBase } from '@src/shared/tables/ngx-datatable-base';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ImportedDataService } from '@src/services/importedData.service';

@Component({
    selector: 'app-imported-retailers-error-list',
    templateUrl: './imported-retailers-error-list.component.html'
})
export class ImportedRetailersErrorComponent extends NgxDatatableBase {
    importedRetailerFileErrors: ImportedFileError[] = [];
    fileId: number;
    onLoading = false;

    constructor(private importDataService: ImportedDataService,
        private route: ActivatedRoute,
        translateService: TranslateService) {
        super(translateService);
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.fileId = +params['id'];
                this.onLoading = true;

                this.importDataService.getRetailerLogErrors(this.fileId).subscribe(
                    errors => {
                        this.importedRetailerFileErrors = errors.sort((a,b) => a.lineFile > b.lineFile ? 1 : -1);
                        this.onLoading = false;
                    }
                );
            }
        });
    }
}